'use client';
import React from 'react';
import Modal from './Modal';
import Icon from '@/components/ui/AppIcon';

interface ConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmLabel?: string;
  variant?: 'danger' | 'warning';
  loading?: boolean;
}

export default function ConfirmModal({
  open, onClose, onConfirm, title, message,
  confirmLabel = 'Confirm', variant = 'danger', loading = false,
}: ConfirmModalProps) {
  return (
    <Modal open={open} onClose={onClose} title={title} size="sm">
      <div className="flex gap-4">
        <div className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${variant === 'danger' ? 'bg-red-50' : 'bg-amber-50'}`}>
          <Icon name="ExclamationTriangleIcon" size={20} className={variant === 'danger' ? 'text-red-600' : 'text-amber-600'} />
        </div>
        <div>
          <p className="text-sm text-foreground leading-relaxed">{message}</p>
        </div>
      </div>
      <div className="flex gap-3 mt-6 justify-end">
        <button onClick={onClose} className="px-4 py-2 text-sm border border-border rounded-md hover:bg-muted transition-colors">
          Cancel
        </button>
        <button
          onClick={onConfirm}
          disabled={loading}
          className={`px-4 py-2 text-sm rounded-md font-500 transition-all active:scale-95 disabled:opacity-60 flex items-center gap-2 ${
            variant === 'danger' ? 'bg-red-600 text-white hover:bg-red-700' : 'bg-accent text-accent-foreground hover:bg-amber-500'
          }`}
        >
          {loading && <span className="w-3.5 h-3.5 border-2 border-white/30 border-t-white rounded-full animate-spin" />}
          {confirmLabel}
        </button>
      </div>
    </Modal>
  );
}